import React from "react";
import "./style.css";
import MainHeading from "../../GlobalComponents/Utils/mainHeading";
import awardImg from "../../Assets/award.png"
import { useTranslation } from "react-i18next";

export default function Award() {
    const { t ,i18n} = useTranslation();
    return(
        <div className="award">
            <MainHeading width={'95%'} flexDirection={'column'} align={"center"} content1={t("award.firstpart")} content2={t("award.secondpart")} />
            <img src={awardImg} alt="" srcset="" />
            <p>{t("award.bigpara")}</p>
        </div>
    )
}